import React from 'react';
import { Pagination } from 'react-bootstrap';

const ModalPagination = ({ pageNumber, AmountPage, handlePageChange }) => {

  const renderPageNumbers = () => {
    let items = [];
    // แสดง "หน้าแรก" สำหรับทุกกรณี
    items.push(
      <Pagination.Item key={1} active={pageNumber === 1} onClick={() => handlePageChange(1)}>
       <p style={{ fontSize: '14px', padding: '0',height: "8px" }}>หน้าแรก</p> 
      </Pagination.Item>
    );

    // ถ้า AmountPage มีเพียงหน้าเดียว ให้แสดงเฉพาะหน้าแรกเท่านั้น
    if (AmountPage === 1) {
      return items;
    }

    // แสดงปุ่ม ellipsis ถ้าหน้าแรกห่างจากปัจจุบันเกิน 2
    if (pageNumber > 3) {
      if (pageNumber > 4) {
        items.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
      }
    }

    for (let number = Math.max(2, pageNumber - 2); number <= Math.min(pageNumber + 1, AmountPage - 1); number++) {
      items.push(
        <Pagination.Item key={`page-${number}`} active={number === pageNumber} onClick={() => handlePageChange(number)}>
          <p style={{ fontSize: '14px', padding: '0',height: "8px" }}>{number}</p> 
        </Pagination.Item>
      );
    }

    // แสดง "หน้าสุดท้าย" และปุ่ม ellipsis ถ้าหน้าปัจจุบันห่างจากสุดท้ายเกิน 2
    if (pageNumber < AmountPage - 2) {
      if (pageNumber < AmountPage - 3) {
        items.push(<Pagination.Ellipsis key="ellipsis-end" disabled/> );
      }
      for (let number = Math.max(AmountPage - 1, pageNumber + 1); number <= AmountPage - 1; number++) {
        items.push(
          <Pagination.Item key={`page-${number}`} active={number === pageNumber} onClick={() => handlePageChange(number)}>
             <p style={{ fontSize: '14px', padding: '0',height: "8px" }}>{number}</p> 
          </Pagination.Item>
        );
    }}

    items.push(
      <Pagination.Item key="last" active={pageNumber === AmountPage} onClick={() => handlePageChange(AmountPage)}>
         <p style={{ fontSize: '14px',padding: '0 0 0 0',height: "8px"}}>หน้าสุดท้าย</p> 
       
      </Pagination.Item>
    );
    return items;
  };

  return (
    <div>

      <Pagination className="p-0 justify-content-center " >
        {renderPageNumbers()}

        
      </Pagination>
    </div>

  );
};

export default ModalPagination;
